const constants: Array<any> = [
  {
    resourceName: "SupportResource",
    endPoint: "/supportForm",
  },
];

export default constants;
